import { apiCall } from './_helper';

// Tests whether a EORI number is valid
// Tested and working: 4/6/2025
export const getEORIValidation = async (eoriNumber, GBOnly) => {
  return await apiCall({
    url: `eori/eori?eori=${encodeURIComponent(eoriNumber)}&GBOnly=${GBOnly}`,
    notJSON: true,
  });
};

export const getShipmentDeleteOrCancel = async (headerId) => {
  // /ens/preDeleteShipment?headerId=46
  return await apiCall({
    url: `ens/preDeleteShipment?headerId=${headerId}`,
    method: 'DELETE',
    notJSON: true,
  });
};

export const getAmendOrNot = async (headerId) => {
  // /ens/preDeleteShipment?headerId=46
  return await apiCall({
    url: `ens/preAmmendShipment?headerId=${headerId}`,
    method: 'GET',
    notJSON: true,
  });
};

export const canAddConsignment = async (headerId) => {
  // /ens/preDeleteShipment?headerId=46
  return await apiCall({
    url: `ens/validateConsignmentAddition?headerId=${headerId}`,
    method: 'GET',
    notJSON: true,
  });
};

// Tests whether a description prohibited
// Tested and working: 4/6/2025
export const getDescriptionValidation = async (description) => {
  return await apiCall({
    url: 'ens/validateDescription',
    method: 'POST',
    body: JSON.stringify({
      itemDescription: description,
    }),
    onResponse: async (response) => {
      if (response.status >= 400) {
        return;
      }
      return await response.json();
    },
  });
};

// Gets a list of countries. Used in other places besides registration
// Tested and working: 4/6/2025
export const fetchCountryData = async (fetchEUOnly = 0) => {
  return await apiCall({
    url: `registration/countries?isEU=${fetchEUOnly}`,
    notJSON: true,
  });
};

export const fetchCustomerType = async () => {
  return await apiCall({
    url: 'referencedata/customerTypes',
    notJSON: true,
  });
};

export const fetch360PayCustomerStatuses = async () => {
  return await apiCall({
    url: 'referencedata/customerStatus360Pay',
    notJSON: true,
  });
};

// Returns a list of statuses for jobs and their associated ids
// Tested and working: 4/6/2025
export const getStatusReference = async () => {
  return await apiCall({
    url: 'referencedata/getStatusReference',
    notJSON: true,
  });
};

// Gets reference data for ENS Declaration process
// Tested and working: 4/6/2025
export const getReferenceData = async (urlParam) => {
  return await apiCall({
    url: `referencedata/${urlParam}`,
    notJSON: true,
  });
};

// Gets a list of consignors for the ENS Declaration process
// Tested and working: 4/6/2025
export const getConsignors = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `traders/traderList?companyId=${companyId}&type=consignor`,
    notJSON: true,
  });
};

// Gets a list of consignees for the ENS Declaration process
// Tested and working: 4/6/2025
export const getConsignees = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `traders/traderList?companyId=${companyId}&type=consignee`,
    notJSON: true,
  });
};

// Gets a list of Carriers for the ENS Declaration process
// Tested and working: 4/6/2025
export const getCarriers = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `traders/traderList?companyId=${companyId}&type=carrier`,
    notJSON: true,
  });
};

// Gets a list of Carriers for the ENS Declaration process
// Tested and working: 4/6/2025
export const getDeclarant = async (companyId = parseInt(sessionStorage.getItem('companyid'))) => {
  return await apiCall({
    url: `ens/declarant?companyId=${companyId}`,
    notJSON: true,
  });
};
